module.exports = __webpack_public_path__ + "static/bussinessman24-1d72bdabc10f30598ca5b71943399cf3.jpg";